(function() {
  const cookies = document.cookie.split('; ');

  if (cookies.indexOf('banner_dismissed=true') >= 0) {
    const el = document.querySelector('.banner-alert');
    el.classList.add('d-none');
  } else {
    const el = document.querySelector('.banner-alert');
    el.classList.remove('d-none');
  };
})();

const dismiss = function() {
  const bannerDismiss = document.querySelector('.banner-alert')
      .querySelectorAll('[data-dismiss="alert"]');

  bannerDismiss.forEach( (item) => {
    item.addEventListener('click', (e) => {
      const cookieElements = [
        'banner_dismissed=true',
        'SameSite=Lax',
        'expires=Session',
        'path=/',
      ];

      document.cookie = cookieElements.join('; ');
    });
  });
};

export default dismiss;
